module.exports = __webpack_public_path__ + "static/aei-25ef8cb72d6cb659685172f368028ab5.png";